import { Temporal } from "temporal-polyfill";

const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

/** Normalize timestamps at the transport boundary before formatting them. */
export function formatCredentialTimestamp(value: string | Date): string {
  try {
    const timestamp = value instanceof Date ? value.toISOString() : value;
    return Temporal.Instant.from(timestamp).toLocaleString(undefined, {
      dateStyle: "medium",
      timeStyle: "short",
    });
  } catch {
    return String(value);
  }
}

function toIsoDateString(date: string | null | undefined): string | null {
  if (!date) {
    return null;
  }
  const dateStr = date.slice(0, 10);
  return ISO_DATE_RE.test(dateStr) ? dateStr : null;
}

/** Pure `YYYY-MM-DD` -> `Jan 1, 2027` formatter, parsed at UTC midnight so the
 * displayed day never shifts based on the viewer's local timezone. */
export function formatDate(date: string | null | undefined): string {
  const dateStr = toIsoDateString(date);
  if (!dateStr) {
    return "—";
  }
  const [year, month, day] = dateStr.split("-");
  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    timeZone: "UTC",
  }).format(new Date(Date.UTC(Number(year), Number(month) - 1, Number(day))));
}
